import { z } from 'zod';

export const ClientCreateSchema = z.object({
  name: z.string().trim().min(1, 'Введите имя').max(128),
  description: z.string().trim().max(1024).optional(),
  isInternal: z.boolean().optional(),
});

export const ClientUpdateSchema = z.object({
  name: z.string().trim().min(1).max(128).optional(),
  description: z.string().trim().max(1024).optional(),
  isInternal: z.boolean().optional(),
});

export type ClientCreateInput = z.infer<typeof ClientCreateSchema>;
export type ClientUpdateInput = z.infer<typeof ClientUpdateSchema>;
